import React from 'react';
import PlaceholderTab from './PlaceholderTab';

function DayOfTab() {
  return <PlaceholderTab tabName="Day Of" />;
}

export default DayOfTab;
